import { TEMPLATE_PREVIEW_THUMBNAILS_URL } from 'api/TemplateIndexAPI';
import { RestQueryHookOptions, useRestQuery } from 'utils/hooks/api';

export const useQueryTemplateThumbnails = (templateIds: number[], options?: RestQueryHookOptions) =>
  useRestQuery<Record<number, string>, { templateIds: number[] }>(
    TEMPLATE_PREVIEW_THUMBNAILS_URL,
    { templateIds },
    {
      ...options,
      enabled: !!templateIds.length,
    },
  );
